import { FieldConfig } from 'model/deals.model';
import zeplinColor from '../theme/Color';

export class Constants {
  public static readonly ErrorType = {
    NotFound: 'UserNotFoundException',
    NotAuthourized: 'NotAuthorizedException',
    LimitExceeded: 'LimitExceededException',
    ExpiredCode: 'ExpiredCodeException',
  };
  public static readonly ErrorText = {
    ExpiredCodeException: 'Code expired',
    LimitExceededException: 'Attempt limit exceeded. Try again later',
    UserNotFoundException: 'User Not Found',
    NotAuthorizedException: 'Wrong password. Try again or click Forgot password to reset it',
    CodeMismatchException: 'Code not matched.',
  };

  public static readonly PriorityTask = {
    Normal: zeplinColor.Blue,
    Low: zeplinColor.AlertInfo,
    High: zeplinColor.Error,
  };

  public static readonly StatusTask = {
    'To Do': zeplinColor.AlertInfo,
    'In Progress': zeplinColor.Blue,
    Done: zeplinColor.Error,
  };

  public static readonly DealsText = {
    totalDealsWon: 'Monthly Closed Deals',
    totalOpenDeals: 'Monthly Open Deals',
    quaterly: 'Quarterly Revenue',
    totalTasks: 'Tasks Completed',
  };
  public static readonly DealsColor = {
    totalDealsWon: zeplinColor.Blue1,
    totalOpenDeals: zeplinColor.Yellow,
    quaterly: zeplinColor.Green,
    totalTasks: zeplinColor.Blue2,
  };
  public static readonly privacyOptions = [
    {
      label: 'A&A Management Group',
      value: 'public_to_workspace',
      description: 'Everyone in your organization can find and access this project.',
    },
    {
      label: 'Shared with team',
      value: 'private_to_team',
      description: 'Only this team and invited members can find and access this project.',
    },
    {
      label: 'Private to members',
      value: 'private',
      description: 'Only invited members can find and access this project.',
    },
  ];
}

export enum Error {
  NotFound = 'UserNotFoundException',
  NotAuthourized = 'NotAuthorizedException',
  LimitExceeded = 'LimitExceededException',
  ExpiredCode = 'ExpiredCodeException',
  CodeMismatch = 'CodeMismatchException',
}

export enum ClientType {
  Talent = 'Talent',
  Athlete = 'Athlete',
  Business = 'Business Development',
}

export const CALENDAR_PALETTE = [
  zeplinColor.Brand1,
  zeplinColor.Blue5,
  zeplinColor.USER_PROFILE_COLOR1,
  zeplinColor.USER_PROFILE_COLOR2,
  zeplinColor.USER_PROFILE_COLOR4,
  zeplinColor.AlertInfo,
  zeplinColor.USER_PROFILE_COLOR8,
  zeplinColor.USER_PROFILE_COLOR13,
  zeplinColor.USER_PROFILE_COLOR9,
  zeplinColor.USER_PROFILE_COLOR10,
  zeplinColor.USER_PROFILE_COLOR11,
  zeplinColor.USER_PROFILE_COLOR12,
];

export const CALENDAR_PROVIDERS = [
  { label: 'Huddle', type: 'huddle' },
  { label: 'Zoom', type: 'zoom' },
  { label: 'Google Meet', type: 'google' },
  { label: 'Microsoft Teams', type: 'microsoft' },
];

export const SHARED_TOP_FIELDS: FieldConfig[] = [
  { name: 'dealDetails.name', label: 'Opportunity name', type: 'text', sm: 6, required: true },
  {
    name: 'dealDetails.clientName',
    label: 'Client name',
    type: 'autocomplete',
    autocompleteType: 'client',
    sm: 6,
    required: true,
  },
  {
    name: 'dealDetails.ownerName',
    label: 'Opportunity owner',
    type: 'autocomplete',
    autocompleteType: 'owner',
    sm: 6,
    required: true,
  },
  {
    name: 'dealDetails.probability',
    label: 'Probability (%)',
    type: 'text',
    sm: 6,
    required: true,
  },
];
